import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ObjectPageComponent} from 'features/core/shared/object/mvs-object-page-component/object-page.component';
import {MvsCoreService} from 'features/core/shared/service/mvs-core.service';

/**
* Object-Page for cn.CommissionRule (FR-3).
*
* CommissionRule is a Complex Configuration Entity (Tier + Condition + Hook children),
* so it is edited on this dedicated Object-Page via CnCommissionRuleObjectComponent
* (left-nav: Allgemein / Staffeln / Bedingungen / Cap / LogicHook / Haftung-Kaution / Vorschau).
* Inline / sub-editor rendering is forbidden (CONFIG-003).
*
* NOTE (architecture shell): the hosted CnCommissionRuleObjectComponent is provided by the
* Component Specialist (FE-T4); CommissionRuleService.getObjectComponent() resolves it for the
* click-chain. This file is the routed page shell that resolves the object identifier.
*/
@Component({
    selector: 'mvs-cn-commission-rule-object-page',
    templateUrl: './cn-commission-rule-object.page.html',
    styleUrls: ['./cn-commission-rule-object.page.scss'],
    standalone: false
})
export class CnCommissionRuleObjectPage
    extends ObjectPageComponent
    implements OnInit, OnDestroy, OnChanges {

    defaultLabel: string = 'Provisionsregel';

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    override ngOnInit(): void {
        this.defaultLabel = 'Provisionsregel';
        super.ngOnInit();
    }

    protected override getObjectType(): string {
        return 'cn.CommissionRule';
    }
}
